import type {
  HttpTransportPort,
  HttpTransportRequestOptions,
  HttpTransportResponse,
} from '@core/domain/ports/driven/HttpTransportPort.ts';

export class FetchHttpAdapter implements HttpTransportPort {
  async request(url: string, options: HttpTransportRequestOptions): Promise<HttpTransportResponse> {
    const { method, headers, body, timeoutMs, signal: externalSignal } = options;

    let signal = externalSignal;
    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    if (timeoutMs && !externalSignal) {
      const controller = new AbortController();
      signal = controller.signal;
      timeoutId = setTimeout(() => controller.abort(), timeoutMs);
    }

    try {
      const response = await fetch(url, {
        method,
        headers,
        body,
        mode: 'cors',
        ...(signal ? { signal } : {}),
      });

      return {
        status: response.status,
        ok: response.ok,
        getHeader: (name: string) => response.headers.get(name),
        text: () => response.text(),
        json: () => response.json(),
      };
    } finally {
      if (timeoutId) clearTimeout(timeoutId);
    }
  }
}
